import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../../config/firebase";
import { get, ref } from "firebase/database";
import { setUser } from "../../reduxSlices/auth/authSlice";

const AppInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const uid = firebaseUser.uid;
          const snapshot = await get(ref(db, `users/${uid}`));
          const userData = snapshot.val();

          let companyName = "";
          if (userData?.companyId) {
            const companySnap = await get(ref(db, `companies/${userData.companyId}/name`));
            companyName = companySnap.exists() ? companySnap.val() : "";
          }

          dispatch(setUser({
            id: uid,
            email: firebaseUser.email,
            companyName,
            ...userData,
          }));
        } catch (err) {
          console.error("Error fetching user:", err);
          dispatch(setUser(null)); // fallback
        }
      } else {
        // 🔥 This is CRUCIAL to unfreeze splash when signed out
        dispatch(setUser(null));
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return null;
};

export default AppInitializer;